import { render, staticRenderFns } from "./SubTotal.vue?vue&type=template&id=31a709c5&scoped=true&"
import script from "./SubTotal.vue?vue&type=script&lang=ts&"
export * from "./SubTotal.vue?vue&type=script&lang=ts&"
import style0 from "./SubTotal.vue?vue&type=style&index=0&id=31a709c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a709c5",
  null
  
)

export default component.exports